import axios from "axios";
import { store } from "../app/store";
import { logout } from "../features/auth/authSlice";
import { toast } from "react-toastify";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,  
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

/* REQUEST INTERCEPTOR */
api.interceptors.request.use(
  (config) => {
    // Remove content-type for FormData
    if (config.data instanceof FormData && config.headers) {
      delete config.headers["Content-Type"];
    }

    // Get token from Redux
    const state = store.getState();
    const token = state?.auth?.accessToken;

    // Attach token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* RESPONSE INTERCEPTOR */
api.interceptors.response.use(
  (response) => {
const showSuccessToast = response.config?.showSuccessToast;

if (showSuccessToast && response?.data?.message) {
  toast.success(response.data.message);
}

    return response;
  },
  (error) => {
    const status = error.response?.status;
    const message =

      error.response?.data?.message || "Something went wrong";

    const skipToast = error.config?.skipToast;

    // Unauthorized
   // Unauthorized
if (status === 401) {
  const currentPath = window.location.pathname;

  // LOGIN PAGE INVALID CREDENTIALS
  if (
    currentPath === "/login" ||
    currentPath === "/create-account"
  ) {
    toast.error(message || "Invalid credentials");

    return Promise.reject(error);
  }

  // SESSION EXPIRED
  toast.error("Session expired. Please login again.");

  store.dispatch(logout());

  localStorage.removeItem("token");

  window.location.href = "/login";

  return Promise.reject(error);
}

    // Validation Error
    if (status === 422) {
      const errors = error.response?.data?.errors;

      if (Array.isArray(errors)) {
        toast.error(errors.join(", "));
      } else {
        toast.error(message);
      }

      return Promise.reject(error);
    }

    // Forbidden
    if (status === 403) {
      toast.warning("You are not authorized");
    }

    // Server Error
    else if (status >= 500) {
      toast.error("Server error. Please try again later");
    }

    // Other Errors
    else if (!skipToast) {
      toast.error(message);
    }

    return Promise.reject(error);
  }
);

/* COMMON API METHODS */

const service = {
  get: (url, params = {}, config = {}) =>
    api.get(url, { params, ...config }),

  post: (url, data = {}, config = {}) =>
    api.post(url, data, config),

  put: (url, data = {}, config = {}) =>
    api.put(url, data, config),

  patch: (url, data = {}, config = {}) =>
    api.patch(url, data, config),

  delete: (url, config = {}) =>
    api.delete(url, config),

  upload: (url, data, config = {}) =>
    api.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      ...config,
    }),
};

export default service;